import React, { useState } from "react";
import { Volume2 } from "lucide-react";

export default function PronounceButton({ text, testId = "pronounce-btn", size = "md" }) {
  const [playing, setPlaying] = useState(false);

  const speak = () => {
    if (!("speechSynthesis" in window)) return;
    try {
      const u = new SpeechSynthesisUtterance(text);
      u.rate = 0.92;
      u.pitch = 1.05;
      u.lang = "en-US";
      u.onstart = () => setPlaying(true);
      u.onend = () => setPlaying(false);
      u.onerror = () => setPlaying(false);
      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(u);
    } catch {
      setPlaying(false);
    }
  };

  const sizing = size === "lg" ? "h-12 w-12" : size === "sm" ? "h-8 w-8" : "h-10 w-10";

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={speak}
      aria-label={`Pronounce ${text}`}
      className={`${sizing} inline-flex items-center justify-center brutal-sm bg-lime brutal-hover brutal-active ${playing ? "animate-pulse" : ""}`}
      title="Hear it"
    >
      <Volume2 className="h-5 w-5" strokeWidth={3} />
    </button>
  );
}
